import { CacheRepository } from './iCacheRepository';
import { CacheKeys } from './cacheKeys';

export class DictCache implements CacheRepository {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private cache: Partial<{ [key: string]: any }> = {};

    public get<T>(key: CacheKeys): T {
        return this.cache[key] as T;
    }

    public set<T>(key: CacheKeys, value: T): boolean {
        this.cache[key] = value;
        return true;
    }

    public delete(key: CacheKeys): boolean {
        delete this.cache[key];
        return typeof this.cache[key] === 'undefined';
    }
}
